import { User } from '../../_model/user/user.model';

export const FakeUserInfo = new User(true);
FakeUserInfo.name = '奥特曼';
FakeUserInfo.nickname = '我是小飞猪123';
FakeUserInfo.gender = 'female';
FakeUserInfo.region = '俄罗斯';
FakeUserInfo.level = 8;
FakeUserInfo.dnCoins = 235511;
FakeUserInfo.membership = 'cpvip';
FakeUserInfo.daysOfMembership = -327;
FakeUserInfo.permissions = ['view-hd-video', 'view-std-video', 'download-video'];
